"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentException = void 0;
exports.groupExceptions = groupExceptions;
exports.getTopPriorityExceptions = getTopPriorityExceptions;
exports.getExceptionMessage = getExceptionMessage;
var jsx_runtime_1 = require("preact/jsx-runtime");
var ExceptionIcon_1 = require("./icons/ExceptionIcon");
var exceptionPriorityList = [
    'prepayment_required',
    'direct_payment_required',
    'held_at_customs',
    'incorrect_address',
    'inaccurate_object_details',
    'requested_hold_to_collect',
    'requested_hold_to_deliver',
    'change_of_address_request',
    'wrong_item',
    'not_ready_for_release',
    'not_ready_for_delivery',
    'damaged_items',
    'lost_in_transit',
    'other',
];
function groupExceptions(shipment) {
    return shipment.shipment_exceptions
        .filter(function (e) { return e.status !== 'resolved'; })
        .reduce(function (acc, e) {
        var typeId = e.type.id;
        if (!acc[typeId]) {
            acc[typeId] = [];
        }
        acc[typeId].push(e);
        return acc;
    }, {});
}
function getTopPriorityExceptions(groupedExceptions) {
    if (!groupedExceptions) {
        return [];
    }
    var currentExceptionType = exceptionPriorityList.find(function (type) { return groupedExceptions[type] && groupedExceptions[type].length > 0; });
    if (currentExceptionType) {
        return groupedExceptions[currentExceptionType];
    }
    return [];
}
function heldAtCustomsMessage(config, topPriorityExceptions, shipment) {
    var packageIds = shipment.packages.map(function (pkg) { return pkg.id; });
    var topPriorityExceptionPackageIds = topPriorityExceptions.map(function (exception) { return exception.package_id; });
    var hasGenericExceptions = topPriorityExceptionPackageIds.includes(null);
    var hasAllPackageIds = packageIds.every(function (id) {
        return topPriorityExceptionPackageIds.includes(id);
    });
    if (hasGenericExceptions || hasAllPackageIds) {
        return config.text.singleShipmentHeldAtCustomsLabel;
    }
    return config.text.multipleShipmentsHeldAtCustomsLabel;
}
function getExceptionMessage(config, topPriorityExceptions, shipment) {
    if (topPriorityExceptions.length === 0) {
        return null;
    }
    var exceptionTypeId = topPriorityExceptions[0].type.id;
    switch (exceptionTypeId) {
        case 'prepayment_required':
        case 'direct_payment_required':
            return config.text.paymentRequiredLabel;
        case 'requested_hold_to_collect':
        case 'requested_hold_to_deliver':
            return config.text.holdRequestedLabel;
        case 'held_at_customs':
            return heldAtCustomsMessage(config, topPriorityExceptions, shipment);
        case 'change_of_address_request':
            return config.text.changeOfAddressRequestLabel;
        default:
            return config.text.shipmentExceptionDefaultLabel;
    }
}
var ShipmentException = function (_a) {
    var config = _a.config, shipment = _a.shipment;
    var topPriorityExceptions = getTopPriorityExceptions(groupExceptions(shipment));
    var expcetionMessage = getExceptionMessage(config, topPriorityExceptions, shipment);
    var currentException = topPriorityExceptions[0];
    if (!expcetionMessage) {
        return (0, jsx_runtime_1.jsx)("div", {});
    }
    return ((0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__exception__wrapper", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ExceptionIcon_1.ExceptionIcon, { config: config, currentException: currentException }) }), (0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__exception__content", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__exception__title", children: expcetionMessage }), (0, jsx_runtime_1.jsx)("a", { href: "mailto:".concat(config.navigation.shipmentExceptionMailTo), class: "artajs__tracking__exception__cta", children: config.text.shipmentExceptionCTA })] })] }));
};
exports.ShipmentException = ShipmentException;
